import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {IconPath} from '@src/app/shared/common/icons';
import {AppointmentType} from '@src/app/shared/models/data/appointment-types/AppointmentType';
import {AppointmentListItem} from '@src/app/shared/models/data/appointments/AppointmentListItem';
import {
  ConsultationPopupRibbonService
} from '@src/app/shared/services/core/consultation-popup/consultation-popup-ribbon.service';
import {AppointmentUtil} from '@models/data/appointments/Appointment';
import {Subject} from 'rxjs';
import { LocalizedDatePipe } from '@shared/pipes/localized-date/localized-date.pipe';
import { ConsultStartStopBtnComponent } from '../consult-start-stop-btn/consult-start-stop-btn.component';
import { IconComponent } from '../../../../../shared/components/icon/icon.component';

import { EdFitMedProfileExtrasmallComponent } from '../../../../../shared/modules/entity-details/fitmedprofiles/ed-fit-med-profile-extrasmall/ed-fit-med-profile-extrasmall.component';

@Component({
    selector: 'app-consultation-popup-item',
    templateUrl: './consultation-popup-item.component.html',
    styleUrls: ['./consultation-popup-item.component.scss'],
    standalone: true,
    imports: [EdFitMedProfileExtrasmallComponent, IconComponent, ConsultStartStopBtnComponent, LocalizedDatePipe]
})

/**
 * Class ConsultationPopupItemComponent implements consultation item component
 */
export class ConsultationPopupItemComponent implements OnInit, OnDestroy {
  private unsub = new Subject<void>();
  private appointmentValue: AppointmentListItem = null;
  appointmentTypeIconValue: IconPath = null;
  appointmentStarted = false;
  rainbowLoading = false;

  // Inject appointment from HTML and set appointmentValue
  @Input() set appointment(content: AppointmentListItem) {
    this.appointmentValue = content;

    // set appointment icon
    this.appointmentTypeIconValue = AppointmentType.mapToIcon(content.appointmentType.name);

    this.appointmentStarted = AppointmentUtil.isAppointmentInProgress(content.appointment);
  }

  // get appointmentValue
  get appointment(): AppointmentListItem {
    return this.appointmentValue;
  }

  constructor(
    public consultationPopup: ConsultationPopupRibbonService,
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.unsub.next();
    this.unsub.complete();
  }

  /**
   * Will try to start the call for the activity when clicked if it is in progress and is audio / video
   */
  startCall(): void {
    this.consultationPopup.startCallBasedOnActiveAppointment();
  }
}
